import { useState } from 'react';
import { Select, Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { personsApi } from '../../api/endpoints/persons';

interface PersonSelectProps {
  value?: number | null;
  onChange?: (value: number | undefined) => void;
  placeholder?: string;
  accountId?: number;
  allowClear?: boolean;
}

export function PersonSelect({
  value,
  onChange,
  placeholder = 'Buscar contacto…',
  accountId,
  allowClear = true,
}: PersonSelectProps): JSX.Element {
  const [search, setSearch] = useState('');

  const { data, isFetching } = useQuery({
    queryKey: ['persons', 'lookup', search, accountId],
    queryFn: () =>
      personsApi.list({
        page: 1,
        pageSize: 20,
        search: search || undefined,
        accountId,
        sortDir: 'asc',
      }),
  });

  const options =
    data?.data.map((p) => ({
      label: `${p.firstName ?? ''} ${p.lastName}`.trim(),
      value: p.id,
    })) ?? [];

  return (
    <Select
      showSearch
      allowClear={allowClear}
      placeholder={placeholder}
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? undefined)}
      onSearch={setSearch}
      filterOption={false}
      notFoundContent={isFetching ? <Spin size="small" /> : 'Sin resultados'}
      options={options}
      style={{ width: '100%' }}
    />
  );
}
